import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import UpdatableApp from './components/app/UpdatableApp';
import initFontAwesome from './initFontAwesome';
import { ServiceWorkerProvider } from './components/hooks/useServiceWorker';
import reportWebVitals from './reportWebVitals';
import './custom.scss';

initFontAwesome();
Modal.setAppElement('#root');

ReactDOM.render(
  <React.StrictMode>
    <ServiceWorkerProvider>
      <UpdatableApp />
    </ServiceWorkerProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
